import { render, staticRenderFns } from "./buttonSub.vue?vue&type=template&id=2512fca6"
import script from "./buttonSub.vue?vue&type=script&lang=js"
export * from "./buttonSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports